import React from 'react';

import { GetShotDateString } from "../../../components/common/Common";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

const SelectChildrens = ({varChildrenIndex,varPopupChildrens,varChildrenList,ClosePopupChildrens,SelectChildrenHandler}) => {
  const onSelectedChildrenHandler = (e,ch_idx) => {
    const childBoxes = document.querySelectorAll('.chidx');
    for(var i=0; i<childBoxes.length; i++) { childBoxes[i].classList.remove('active'); }
    e.currentTarget.classList.add('active');
    SelectChildrenHandler(ch_idx);
  }
  return (
    <>
      <div className={varPopupChildrens?"layer-bg open":"layer-bg"}></div>
      <div className="layer-pop layer-kids" style={varPopupChildrens?{display:"block"}:{display:"none"}}>
        <div className="layer-hd">
          <div className="tit">아이 선택</div>
          <div className="close-layer" onClick={()=>ClosePopupChildrens()}><img src={cancelIcon} alt=""/></div>
        </div>
        <div className="check-group vertical">
          {varChildrenList.map((children,i)=>(
            <div className="checkbox2" key={'children_'+i}>
              <input type="radio" name="radioName" value={children.ch_idx}/>
              <label className={children.ch_idx===varChildrenIndex?"chidx active":"chidx"} onClick={e=>onSelectedChildrenHandler(e,children.ch_idx)}>
                <div className="value">
                  <div className="name">{children.ch_name}</div>
                  <div className="date">{GetShotDateString(children.ch_birthday)}</div>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
export default SelectChildrens;